import axios from 'axios'
import store from '../../store/index'

const state = {
  authenticationData: JSON.parse(localStorage.getItem('inside')),
  status: !!(localStorage.getItem('inside')),
}

const mutations = {
  auth_request (state) {
    state.status = false
  },
  auth_success (state, token) {
    state.status = true
    localStorage.setItem('inside', token)
    state.authenticationData = JSON.parse(localStorage.getItem('inside'))
  },
  register_success (state, token) {
    state.status = true
    localStorage.setItem('inside', token)
    state.authenticationData = JSON.parse(localStorage.getItem('inside'))
  },
  auth_error (state) {
    state.status = false
  },
  logout (state) {
    state.status = false
    localStorage.removeItem('inside')
    state.authenticationData = ''
  },
}

const actions = {
  login ({ commit }, userLogin) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/auth/login',
        data: userLogin,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          const authenticationResp = JSON.stringify(resp.data.message)
          commit('auth_success', authenticationResp)
          resolve(resp)
        })
        .catch(err => {
          localStorage.removeItem('inside')
          reject(err)
        })
    })
  },
  loginGoogle ({ commit }, userLogin) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/auth/google',
        data: userLogin,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          const authenticationResp = JSON.stringify(resp.data.message)
          commit('auth_success', authenticationResp)
          resolve(resp)
        })
        .catch(err => {
          localStorage.removeItem('inside')
          reject(err)
        })
    })
  },
  register ({ commit }, userRegister) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/auth/register',
        data: userRegister,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          const authenticationResp = JSON.stringify(resp.data.message)
          commit('register_success', authenticationResp)
          resolve(resp)
        })
        .catch(err => {
          localStorage.removeItem('inside')
          reject(err)
        })
    })
  },
  resetPassMail ({ commit }, resetPassMail) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/auth/sentResetPassMail',
        data: resetPassMail,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  resetPassTokenValidation ({ commit }, resetPassToken) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/auth/resetPassTokenValidation?token=' + resetPassToken,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  resetPass ({ commit }, resetPass) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/auth/resetPass',
        data: resetPass,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  confirmEmail ({ commit }, confirmEmailToken) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/auth/confirmationEmail?token=' + confirmEmailToken,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  confirmEmailRequest ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/auth/requestConfirmationEmail',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
